<template>
  <div ref="root">
    <slot></slot>
    <div ref="observee" class="position-relative">
      <div class="mt-5 spinner-wrapper" v-if="hasMoreItems">
        <spinner class="spinner" />
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'

/**
 * This gives infinite scroll capability. Whenever scroll reaches at the bottom, it emits an event - @bottom
 */
export default {
  name: 'InfiniteScroll',
  props: {
    /**
     * If true, loader at the bottom is shown
     */
    hasMoreItems: Boolean,
    root: {
      default: document.querySelector('#main-scrolling'),
      type: HTMLElement
    },
    rootMargin: String
  },
  components: {
    Spinner
  },
  methods: {
    callback(entries) {
      const entry = entries[0]
      if (entry.isIntersecting && this.hasMoreItems) {
        this.$emit('bottom')
      }
    }
  },
  mounted() {
    const options = {
      root: this.root,
      rootMargin: this.rootMargin,
      threshold: 0
    }
    this.observer = new IntersectionObserver(this.callback, options)
    this.observer.observe(this.$refs.observee)
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.observee)
  }
}
</script>

<style lang="scss" scoped>
.spinner-wrapper {
  height: 35px;
}
.spinner {
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
}
</style>
